import { render, staticRenderFns } from "./PresentingComplaintsStatus.vue?vue&type=template&id=0a80b286&scoped=true&"
import script from "./PresentingComplaintsStatus.vue?vue&type=script&lang=js&"
export * from "./PresentingComplaintsStatus.vue?vue&type=script&lang=js&"
import style0 from "./PresentingComplaintsStatus.vue?vue&type=style&index=0&id=0a80b286&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a80b286",
  null
  
)

export default component.exports